export class OrganisationTreeModel {
    public organisationId: string;
    public organisationCallName: string;
    public statusCode: string;
    public children: OrganisationTreeModel[];
}